<script setup lang="ts">
import Select2 from "@/components/frontend/ui/Select2.vue";
import { ref, watch } from "vue";
import { formatStageTemplate } from '@/utils/stage';
const props = defineProps({
  modelValue: {
    type: Array,
    default: () => []
  },
  stages: {
    type: Array,
    default: () => []
  },
  required: {
    type: Boolean,
    default: false
  },
  disabled : {
    type: Boolean,
    default: false
  },
  error : {
    type: String,
    default: null
  },
})

const selectedStage = ref<any|null>(props.modelValue?.[0] || null);

watch(() => props.modelValue, (newValue) => {
  selectedStage.value = newValue[0];
});

const emits = defineEmits(['update:modelValue']);
watch(() => selectedStage.value, (newValue) => {
  emits('update:modelValue', newValue ? [newValue] : []);
});

</script>

<template>
<div>
  <div class="form-group" :class="{ 'has-danger has-error': !!props.error }">
    <label>
      {{ $t("Choose your date") }}
      <small v-if="props.required" class="align-middle font-weight-bold text-danger">*</small>
    </label>
    <Select2 v-model="selectedStage" style="width: 100%"
             :options="props.stages"
             :disabled="props.disabled"
             :select2Options="{
                  templateResult: formatStageTemplate(),
             }"
              :placeholder="$t('Select your date')"
             v-cloak>
    </Select2>
    <div class="invalid-feedback" :class="{'d-block' : !!props.error }"
         v-if="!!props.error" v-cloak>
      {{ props.error }}
    </div>
  </div>
</div>
</template>

<style scoped>

</style>